module.exports = __webpack_public_path__ + "static/tanaka_733-b6ab29241748b6c79f00bab12963f53e.jpg";